import { service } from '../../../../helpers/http'

export const ActionGetScenarios = ({ dispatch }, payload) => {
    return service({
        module: 'domainScenario',
        action: 'getScenarios',
        payload: payload
    })
}

export const ActionGetScenario = ({ dispatch }, payload) => {
    return service({
        module: 'domainScenario',
        action: 'getScenario',
        payload: payload
    })
}

export const ActionPostScenario = ({ dispatch }, payload) => {
    return service({
        module: 'domainScenario',
        action: 'postScenario',
        payload: payload
    })
}

export const ActionPutScenario = ({ dispatch }, payload) => {

    const { id, ...body } = payload

    // {id} preenche a rota; nome/descrição vão no corpo.
    return service({
        module: 'domainScenario',
        action: 'putScenario',
        params: { id },
        payload: body
    })
}

export const ActionPostBatch = ({ dispatch }, payload) => {
    return service({
        module: 'domainScenario',
        action: 'postBatch',
        payload: payload
    })
}

export const ActionDeleteScenario = ({ dispatch }, payload) => {
    return service({
        module: 'domainScenario',
        action: 'deleteScenario',
        payload: payload
    })
}

export const ActionGetScenarioItems = ({ dispatch }, payload) => {

    // A rota possui o parametro {id}. Para um GET, o vue-resource monta a URL
    // e a query string a partir do primeiro argumento (params). Por isso o
    // "id" (que preenche {id}) e os filtros de paginacao (page/per_page/search,
    // que viram query string) precisam ir juntos no mesmo objeto "params".
    const routeAndQuery = { id: payload.id }
    if (payload.page != null) routeAndQuery.page = payload.page
    if (payload.per_page != null) routeAndQuery.per_page = payload.per_page
    if (payload.search) routeAndQuery.search = payload.search
    // AutoFiltro por coluna: enviado como JSON na query string.
    if (payload.filters && Object.keys(payload.filters).length) {
        routeAndQuery.filters = JSON.stringify(payload.filters)
    }

    return service({
        module: 'domainScenario',
        action: 'getScenarioItems',
        params: routeAndQuery
    })
}

export const ActionGetBaseGroupStatus = ({ dispatch }) => {
    return service({
        module: 'domainScenario',
        action: 'getBaseGroupStatus'
    })
}

export const ActionGetScenarioItemsDistinct = ({ dispatch }, payload) => {

    // Valores distintos de uma coluna para o checklist do AutoFiltro.
    // Os demais filtros ativos e a busca acompanham para refletir a visão atual.
    const routeAndQuery = { id: payload.id, column: payload.column }
    if (payload.search) routeAndQuery.search = payload.search
    if (payload.term) routeAndQuery.term = payload.term
    if (payload.filters && Object.keys(payload.filters).length) {
        routeAndQuery.filters = JSON.stringify(payload.filters)
    }
    // Filtro-base "apenas ofertáveis" enviado à parte (sempre aplicado no backend).
    if (payload.baseFilters && Object.keys(payload.baseFilters).length) {
        routeAndQuery.base_filters = JSON.stringify(payload.baseFilters)
    }

    return service({
        module: 'domainScenario',
        action: 'getItemsDistinct',
        params: routeAndQuery
    })
}

export const ActionPutScenarioItem = ({ dispatch }, payload) => {

    const { id, itemId, ...body } = payload

    // A rota possui dois parâmetros ({id} e {itemId}). O helper http
    // só extrai o "id" automaticamente do payload, então passamos os
    // parâmetros de rota explicitamente via "params".
    return service({
        module: 'domainScenario',
        action: 'putScenarioItem',
        params: { id, itemId },
        payload: body
    })
}

export const ActionBulkUpdateItems = ({ dispatch }, payload) => {

    const { id, ...body } = payload

    // {id} preenche a rota; o corpo (item_ids/column/action/value) vai no payload.
    return service({
        module: 'domainScenario',
        action: 'bulkUpdateItems',
        params: { id },
        payload: body
    })
}

export const ActionGetApplyScenarioPreview = ({ dispatch }, payload) => {
    return service({
        module: 'domainScenario',
        action: 'applyScenarioPreview',
        params: { id: payload.id }
    })
}

export const ActionApplyScenario = ({ dispatch }, payload) => {
    return service({
        module: 'domainScenario',
        action: 'applyScenario',
        params: { id: payload.id }
    })
}

export const ActionGetScenarioIndicators = ({ dispatch }, payload) => {
    return service({
        module: 'domainScenario',
        action: 'getScenarioIndicators',
        params: { id: payload.id }
    })
}
